import { render, staticRenderFns } from "./StoreMoneyBus.vue?vue&type=template&id=1e56346e"
import script from "./StoreMoneyBus.vue?vue&type=script&lang=js"
export * from "./StoreMoneyBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports